<template>
  <div id="topBar">
    <div class="container">
      <div class="columns is-mobile is-gapless">
        <div class="column is-2">
          <a
            v-if="showSayWord"
            class="image is-pulled-right"
            tabindex="-1"
            href="#"
            @keydown.enter.prevent
            @click.prevent="playAudioButtonAction"
          >
            <figure id="playAudioButton">
              <img src="/images/playAudioButton.png">
            </figure>
          </a>
          <span v-if="showScore" class="tag is-large is-pulled-right scoreText">🍯 {{ score }}</span>
          <span v-if="showNumberScore && (score != null || answersGiven != null)" class="tag is-numberScore is-large scoreText"><span v-if="score != null"><i class="emojiIcon emojiStar" />&nbsp;{{ enforceLatinNumberSystem(score) }}</span><span v-if="answersGiven != null" :style="score != null ? 'margin-left: 15px': ''">✅ {{ answersGiven.filter(ans => ans.correct == 1).length }} / {{ answersGiven.length }}</span></span>
          <span v-if="streak" class="tag is-streak-text is-large scoreText" style="z-index: 1; position: relative;">🔥 {{ streak }}</span>
        </div>
        <div id="textBoxColumn" class="column">
          <p v-if="showTextBar" id="textBox" class="input">
            {{ barText }}<span :class="'cursor' + (lastCharSpace ? ' leftMargin' : '')">|</span> <a
              id="backspaceButton"
              tabindex="-1"
              href="#"
              class="is-pulled-right has-text-right"
              @keydown.enter.prevent
              @click.prevent="backspaceButtonAction"
            ><figure class="is-pulled-right"><img src="/images/backspaceButton.png"></figure></a>
          </p>
          <div v-else-if="streak" class="streakContainer">
            <!-- {{ streak }} -->
            <div style="width: fit:content; justify-self: flex-end; flex-direction: row; position: absolute; right: 0; top: 0;" class="is-flex">
              <figure v-for="index in streak" :key="index" class="is-flex" style="justify-content: flex-end;margin-top: auto;">
                <img :src="index === streakMax ? '/images/checkStar.png' : !(index % 10) ? '/images/checkPink.png' : index < streakBreaks[0] ? '/images/check.png' : index < streakBreaks[1] ? '/images/checkFire1.png' : index < streakBreaks[2] ? '/images/checkFire2.png' : '/images/checkFire3.png' " class="checkImage">
              </figure>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <a
            v-if="showEndGame"
            class="is-inline-block"
            tabindex="-1"
            href="#"
            @keydown.enter.prevent
            @click.prevent="endGame"
          ><figure id="endButton" class="image"><img src="/images/CalcButton.png"></figure></a>
          <a
            v-if="!hidePause"
            class="is-inline-block"
            tabindex="-1"
            href="#"
            @keydown.enter.prevent
            @click.prevent="pauseButtonAction"
          ><figure id="pauseButton" class="image"><img src="/images/pauseButton.png"></figure></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { enforceLatinNumberSystem } from '@/edshed-common/api'
export default {
  name: 'TopBar',
  props: ['barText', 'showTextBar', 'showSayWord', 'score', 'showScore', 'showNumberScore', 'answersGiven', 'hidePause', 'streak', 'streakMax', 'streakBreaks', 'showEndGame'],
  data () {
    return {
    }
  },
  computed: {
    lastCharSpace () {
      if (this.barText[this.barText.length - 1] === ' ') {
        return true
      }
      return false
    }
  },
  methods: {
    backspaceButtonAction () {
      console.log('BACKSPACE')
      this.$emit('backspace')
    },
    playAudioButtonAction () {
      console.log('PLAY AUDIO')
      this.$emit('sayword')
    },
    pauseButtonAction () {
      console.log('PAUSE')
      this.$emit('pause')
    },
    endGame () {
      this.$emit('endgame')
    },
    enforceLatinNumberSystem
  }
}
</script>

<style lang="scss" scoped>

.streakContainer {
  position:relative;
  height: 56px;
}

.checkImage {
  margin-top:auto;
  height: fit-content;
  max-width: fit-content;
}

.cursor {
  color: #2E3D48;
  -webkit-animation: 1s blink step-end infinite;
  -moz-animation: 1s blink step-end infinite;
  -ms-animation: 1s blink step-end infinite;
  -o-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
}

.leftMargin {
  margin-left: 10px;
}

@keyframes blink {
  from, to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

@-moz-keyframes blink {
  from, to {
    color: transparent;
  }
  50% {
    color: #2E3D48;
  }
}

@-webkit-keyframes blink {
  from, to {
    color: transparent;
  }
  50% {
    color: #2E3D48;
  }
}

@-ms-keyframes blink {
  from, to {
    color: transparent;
  }
  50% {
    color: #2E3D48;
  }
}

@-o-keyframes blink {
  from, to {
    color: transparent;
  }
  50% {
    color: #2E3D48;
  }
}

#topBar {
/*   background-color: green; */
  width: 100%;
  height: 60px;
  padding:5px;
  position: relative;
  z-index: 20;
}

#playAudioButton, #pauseButton {
  width: 69px;
  max-width:100%;
  background:transparent;
}
#endButton{
  width: 88px;
  position:relative;
  margin-right:10px;
  &:before {
    content: 'End';
    display:block;
    margin:auto;
    text-align: center;
    position:absolute;
    width:100%;
    top:50%;
    transform:translateY(-50%);
    color: #fff;
    font-family: var(--user-chosen-font);
    font-size: 1.4em;
  }
}

#textBoxColumn {
  padding:0 5px !important;
}

#textBox {
/*   background-image: url('/images/textBar.png'); */
  background-size:100% 100%;
  background-repeat:no-repeat;
  height:50px;
  max-width:100%;
  margin: 0 auto;
  box-shadow: 0px 3px 1px #888888;
  font-family: var(--user-chosen-font);
  font-size: 28px;
}
#backspaceButton {
    margin: 12px 0 0 auto
}

#backspaceButton figure {
  width: 45px;
}

.scoreText {
  font-family: var(--user-chosen-font);
}

.is-numberScore {
  background: transparent;
  border: 2px solid white;
  border-radius: 8px;
  color: #fff;
}

.is-streak-text {
  background: linear-gradient(to bottom, #E3D237 30%, #f0a721 100%);
  border: 2px solid rgb(221, 151, 38);
  /* border-bottom: 5px solid #A16C13; */
  border-radius: 8px;
  color: white;
  text-shadow: 2px 2px 8px rgba(0,0,0,0.7);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.7);
  float:right;
}

@media all and (max-width: 569px) {
  #textBox {
    font-size: 16px;
  }

  .is-streak-text {
    float:left;
  }
}

</style>
